__turbopack_context__.v({
  "bleed": "HubCarousel-module__pyzhAW__bleed",
  "dragging": "HubCarousel-module__pyzhAW__dragging",
  "edgeFade": "HubCarousel-module__pyzhAW__edgeFade",
  "scroller": "HubCarousel-module__pyzhAW__scroller",
});
